<template>
  <div>
    <v-dialog v-model="mostrarPopup" persistent>
      <v-card>
        <v-card-title>Seleccione Domicilio</v-card-title>
        <v-card-text>
          <v-row no-gutters v-for="dom in listaDomicilios" :key="dom.id">
            <v-col md="1">
              <v-btn icon @click="seleccionar(dom)"
                ><v-icon>mdi-magnify</v-icon></v-btn
              >
            </v-col>
            <v-col md="3"> {{ dom.domicilio }} </v-col>
            <v-col md="3">
              <cboLocalidades
                readonly
                texto
                :value="{ id_localidad: dom.id_localidad }"
              ></cboLocalidades>
            </v-col>
            <v-col md="3">
              <cboProvincias
                readonly
                texto
                :value="dom.id_provincia"
              ></cboProvincias>
            </v-col>
            <v-col md="2">
              {{ dom.telefono }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-if="domseleccionado">
      <v-row>
        <v-col md="6">
          {{ domseleccionado.domicilio }}
          <cboLocalidades
            readonly
            texto
            :value="{ id_localidad: domseleccionado.id_localidad }"
          ></cboLocalidades>
        </v-col>
        <v-col md="6">
          <cboProvincias
            readonly
            texto
            :value="domseleccionado.id_provincia"
          ></cboProvincias>
          {{ domseleccionado.telefono }}
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import API from "@/lib/API";
import cboLocalidades from "@/components/Localidades/Combo";
import cboProvincias from "@/components/Provincias/Combo";

export default {
  props: {
    id_efector: Number,
    id_domicilio: Number,
  },
  components: {
    cboLocalidades,
    cboProvincias,
  },
  data() {
    return {
      mostrarPopup: false,
      listaDomicilios: [],
      domseleccionado: null,
    };
  },
  methods: {
    async traerPorEfector() {
      if (this.domseleccionado == null) {
        this.listaDomicilios = await API.domiciliosprofesionales.traerPorEfector(
          this.id_efector
        );
        if (this.listaDomicilios.length > 1) {
          this.mostrarPopup = true;
        } else {
          if (this.listaDomicilios.length == 1) {
            this.seleccionar(this.listaDomicilios[0]);
          }
        }
      }
    },
    async traerPorId() {
      if (this.id_domicilio) {
        this.domseleccionado = await API.domiciliosprofesionales.traerUno(
          this.id_domicilio
        );
      }
    },
    seleccionar(domic) {
      this.domseleccionado = domic;
      this.mostrarPopup = false;
      this.$emit("input", domic.id);
    },
  },
  watch: {
    id_efector() {
      if (!this.id_domicilio || this.id_domicilio == 0) {
        this.domseleccionado = null;
        this.traerPorEfector();
      }
    },
    // value(){
    //   alert(this.value);
    // }
    id_domicilio() {
      this.traerPorId();
    },
  },
  mounted() {
    if (!this.id_domicilio) {
      this.traerPorEfector();
    } else {
      this.traerPorId();
    }
  },
};
</script>

<style></style>
